import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorIcon from "@mui/icons-material/Error";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import ShieldIcon from "@mui/icons-material/Shield";
import { Tooltip } from "@mui/material";

export const WITHHELD_TOOLTIP =
  "Withheld by DoubleTake — recorded, not sent to the monitoring center";

export const createDetctionTypeIcon = (
  detection_type: string,
  outcome: any,
  dispatchMuted = false,
  withheldByDoubleTake = false
) => {
  // outcome === null is the browser-applied "Muted" outcome; dispatchMuted is
  // the connector's stamp on the alert record (ENG-1309) — the same state
  // from an authoritative source, shown even if no browser auto-resolved it.
  if (outcome === null || dispatchMuted) {
    return (
      <Tooltip
        title={
          dispatchMuted
            ? "Muted — recorded, not sent to the monitoring center"
            : "Muted"
        }
        placement="top"
        sx={{ fontSize: "14px", fontFamily: "mulish" }}
      >
        <NotificationsOffIcon sx={{ color: "darkgray" }} />
      </Tooltip>
    );
  }
  // ENG-1599: the DoubleTake receiver gate withheld this alarm from
  // Immix/Patriot (dispatch_suppressed_by === "doubletake"). Unlike a mute the
  // alert is NOT auto-resolved: operators still review it, and the outcome they
  // pick is the ground truth the gate is measured against. An operator outcome
  // (true threat etc.) therefore takes precedence over this badge below.
  if (withheldByDoubleTake && !detection_type) {
    return (
      <Tooltip
        title={WITHHELD_TOOLTIP}
        placement="top"
        sx={{ fontSize: "14px", fontFamily: "mulish" }}
      >
        <ShieldIcon sx={{ color: "#7d2e72" }} />
      </Tooltip>
    );
  }
  if (detection_type === "true_threat") {
    return (
      <Tooltip
        title="True Threat"
        placement="top"
        sx={{ fontSize: "14px", fontFamily: "mulish" }}
      >
        <CheckCircleIcon sx={{ color: "#2E7D32" }} />
      </Tooltip>
    );
  } else if (detection_type === "true_non_threat") {
    return (
      <Tooltip
        title="True Non-Threat"
        placement="top"
        sx={{ fontSize: "14px", fontFamily: "mulish" }}
      >
        <CheckCircleIcon sx={{ color: "#FF8400" }} />
      </Tooltip>
    );
  } else if (detection_type === "false_positive") {
    return (
      <Tooltip
        title="False Positive"
        placement="top"
        sx={{ fontSize: "14px", fontFamily: "mulish" }}
      >
        <CancelIcon sx={{ color: "#D32F2F" }} />
      </Tooltip>
    );
  } else if (detection_type === "escalated_true_threat") {
    return (
      <Tooltip
        title="Escalated True Threat"
        placement="top"
        sx={{ fontSize: "14px", fontFamily: "mulish" }}
      >
        <ErrorIcon sx={{ color: "#7d2e72" }} />
      </Tooltip>
    );
  } else return "";
};
